<script>
    import { allProjectFields } from "../../Participaid.svelte";
    import ProjectFieldLib from "../../models/participaid/ProjectField.js";

    import Dialog from "../Dialog.svelte";
    import Emoji from "../Emoji.svelte";
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import Field from "../form/Field.svelte";
    import TextField from "../form/TextField.svelte";
    import FormulaOperationDropdown from "../form/FormulaOperationDropdown.svelte";
    import FormulaTypeDropdown from "../form/FormulaTypeDropdown.svelte";
    import FormulaInputTypeDropdown from "../form/FormulaInputTypeDropdown.svelte";
    import NumberField from "../form/NumberField.svelte";

    import Button, {Label} from '@smui/button';
    import FaIcon from 'fa-svelte';

    export let formula;
    export let isTime;
    export let hoursPerYear = 1600;
    export let commissionPercentage;
    export let disabled;
</script>

<Field class="formula-type">
    <FormulaTypeDropdown bind:selectedId={formula} isTime={isTime} {disabled}/>
</Field>

{#if isTime && formula == "YEAR_SALARY"}
    <Field class="parameter-hours-in-year">
        <NumberField
                class="project-field-hours-per-year"
                min={1}
                max={3000}
                label="The number of hours in a year"
                help="Specify the number of hours you consider to be in a work year in order to calculate the hourly salary equivalent"
                {disabled}
                bind:value={hoursPerYear}
        />
    </Field>
{/if}

{#if formula == "COMMISSION_GENERAL"}
    <Field class="parameter-commission-percentage">
        <NumberField
                class="project-field-commission-percentage"
                min={0}
                max={100}
                step="0.5"
                label="Commission percentage"
                help="The general commission to use for this type of entry (use comma as a decimal separator)"
                {disabled}
                bind:value={commissionPercentage}
        />
    </Field>
{/if}